// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_1j4-U","title":"_302nG"};